export default "__VITE_ASSET__Dfj4Gw6a__"